export default __webpack_public_path__ + "static/media/transaction-success-icon.769d570f.svg";